import { Tooltip, TooltipProps } from 'antd';
import { FC, memo } from 'react';

import { useMediaQueryDevice } from '@/components/MediaQuery';
import { mockOpenTooltip } from '@/constants/mock';

const ResponsiveTooltip: FC<TooltipProps & { showOnMobile?: boolean }> = function (props) {
  const { isMobile } = useMediaQueryDevice();

  // Derive the open prop: only pass it to Tooltip when it is explicitly defined
  const derivedOpen = mockOpenTooltip ? mockOpenTooltip : props.open;
  const openProp = derivedOpen !== undefined ? { open: derivedOpen } : {};

  return isMobile && !props.showOnMobile ? <> {props.children}</> : <Tooltip {...props} {...openProp} />;
};

export default memo(ResponsiveTooltip);
